
import VueApp from '@/@types/app/VueApp';
import { Component, Prop } from 'vue-property-decorator';
import { TextTab } from '@/models/article/TextTab';
import { ElLoadingComponent } from 'element-ui/types/loading';
import { Article } from '@/models/article/Article';

@Component
export default class ArticleTextTabButton extends VueApp {
  loader: ElLoadingComponent = null;

  @Prop({ type: Boolean, default: false }) isActive: boolean;
  @Prop({ type: Boolean, default: false }) isEditMode: boolean;
  @Prop({ type: Array, required: true }) textTabs: TextTab[];
  @Prop({ type: Article, required: true }) article: Article;

  isDropdownOpen = false;

  get activeTextTabId() {
    return this.isEditMode
      ? this.$store.state.articleEditor.activeTextTabId
      : this.$store.state.workspaceView.activeTextTabId;
  }

  get textTabsCount() {
    return this.textTabs.length;
  }

  isTextTabActive(tab: TextTab) {
    return this.activeTextTabId && this.activeTextTabId === tab.id;
  }

  isTextTabPinned(tab: TextTab) {
    if (!tab.id || !this.article.pinnedNote) return false;
    return this.article.pinnedNote === tab.id;
  }

  trimmedTitle(title: string) {
    const charLimit = 13;
    if (title.length > charLimit) {
      return title.slice(0, charLimit) + '...';
    }

    return title;
  }

  handleClick(tab: TextTab) {
    this.$emit('click', tab);
  }
}
